<script>
    import {onMount} from "svelte";
    import {mainTimeline} from "../../timelines/main-timeline";
    import gsap from "gsap";
    import SplitText from 'gsap/SplitText';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

    gsap.registerPlugin(SplitText);
    gsap.registerPlugin(DrawSVGPlugin);

    export let text = "Next";
    let textElement;
    let path;
    let tt;

    onMount(() => {
        const stagger = 0.05;
        const duration = 0.15;

        const textInsertionPoint = 'gnosis0-=1';
        const pathInsertionPoint = 'gnosis0-=1.5';
        const endPoint = 'gnosisEnd-=0.15';

        mainTimeline.from(textElement, {
            autoAlpha: 0,
            duration,
        }, textInsertionPoint)

        mainTimeline.from(path, {
            drawSVG: 0,
            transformOrigin: 'center center',
            duration: 1,
        }, pathInsertionPoint)

        mainTimeline.to(tt, {
            autoAlpha: 0,
            duration,
        }, endPoint);

        const splitText = new SplitText(textElement, {type: 'words, chars'});

        mainTimeline.from(splitText.chars, {
            autoAlpha: 0,
            stagger,
            duration: 0.001,
            ease: 'linear',
        }, textInsertionPoint)
    });

</script>

<svg width="170px" viewBox="0 0 150 200" class="navigate-tooltip" bind:this={tt}>
    <g class="tip-inner-container">
        <foreignObject x=0 y=0 height="50" width="100">
            <body>
                <p class="tip-text" bind:this={textElement}>{text}</p>
            </body>
        </foreignObject>
        <circle r=25 cx="50" cy="50" class="tip-path" bind:this={path} />
    </g>
</svg>

<style>

    .navigate-tooltip {
        pointer-events: none;
    }

    .tip-inner-container {
        position: absolute;
        top: 0;
        left: 0;
    }

    .tip-text {
        color: white;
        margin: 0;
        text-align: center;
    }

    .tip-path {
        fill: none;
        stroke: #FF8833;
        stroke-miterlimit: 10;
        stroke-width: 3px;
    }

</style>